import Image from 'next/image';

import { fontStyles } from '@/styles/typography';

import { sectionTitleClass } from '../shared-styles';

export const MatchaTeamSection = () => (
  <div className="mr-auto mb-20 ml-auto max-w-[1240px] text-center">
    <div className="flex flex-col items-center gap-4">
      <h2 className={sectionTitleClass}>Meet the team behind Matcha</h2>
      <div
        className={fontStyles({
          variant: 'BODY_LG',
          class: 'text-token-gray-1000 max-w-[31rem] leading-6',
        })}
      >
        We believe in building a world where tokenized value flows freely. Join the mission!
      </div>
    </div>

    <div className="tablet:flex-row mt-12 flex flex-col gap-4">
      <div className="flex flex-1 flex-col gap-4">
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-2.jpg"
            width={402}
            height={302}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-5.jpg"
            width={402}
            height={537}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
      </div>
      <div className="tablet:flex hidden flex-1 flex-col gap-4">
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-8.jpg"
            width={402}
            height={302}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-6.jpeg"
            width={402}
            height={268}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-4.jpg"
            width={402}
            height={302}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-4">
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-7.jpeg"
            width={402}
            height={268}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-3.jpg"
            width={402}
            height={268}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
        <div className="h-auto overflow-hidden">
          <Image
            src="/images/about-us/photo-1.jpg"
            width={402}
            height={268}
            alt="A photograph of the 0x team"
            className="h-auto w-full rounded-[8px]"
          />
        </div>
      </div>
    </div>
  </div>
);
